import React from 'react';
import HarbourFlyout from '../../components/harbour/HarbourFlyout';
import HarbourDocumentForm from '../../components/harbour/HarbourDocumentForm';
import HarbourNotice from '../../components/harbour/HarbourNotice';
import HarbourTextLink from '../../components/harbour/HarbourTextLink';
import useMyReferralDocuments from '../../hooks/useMyReferralDocuments';
import { DOCUMENTS_LOAD_FAILED } from '../../utils/referralDocumentPortal';
import '../../components/harbour/harbour.css';

/*
 * SENCO · Add a document (TDI-578, Figma D-01: Empty, Document type list
 * open, Filled in, Errors, Saving, Could not add). A wide task flyout opened
 * from the Documents block in the pupil record's Referral pathway card
 * (D-04), at /rms/pupils/:id/documents/add. Closing or saving goes back to
 * the record.
 */
export default function HarbourAddDocumentFlyout({ pupil, orgId, onClose, onAdded }) {
  const { summary, error, reload } = useMyReferralDocuments({
    orgId,
    patientRecordId: pupil.id,
    enabled: Boolean(pupil.referral),
  });

  return (
    <HarbourFlyout
      width="wide"
      title={pupil.name}
      year={pupil.yearGroup}
      eyebrow={{ tone: 'task', label: 'Add a document' }}
      onClose={onClose}
    >
      {!pupil.referral ? (
        <HarbourNotice kind="info" title="Documents can only be added to a referral">
          {`Add ${pupil.name.split(' ')[0]} to the referral pathway first.`}
        </HarbourNotice>
      ) : !summary && !error ? (
        <div aria-hidden="true" className="flex flex-col gap-5 max-w-[760px]">
          <div className="harbour-skeleton h-[108px] animate-pulse" />
          <div className="harbour-skeleton h-[80px] animate-pulse" />
          <div className="harbour-skeleton h-[80px] animate-pulse" />
        </div>
      ) : error && !summary ? (
        <HarbourNotice kind="error" title="We could not open this form">
          <p>{DOCUMENTS_LOAD_FAILED}</p>
          <HarbourTextLink onClick={() => reload()}>Try again</HarbourTextLink>
        </HarbourNotice>
      ) : (
        <HarbourDocumentForm
          orgId={orgId}
          patientRecordId={pupil.id}
          summary={summary}
          tone="senco"
          layout="desktop"
          onAdded={onAdded}
          onCancel={onClose}
        />
      )}
    </HarbourFlyout>
  );
}
